const destinations = [
  {
    name: "Cancun & Riviera Maya",
    context: "Direct flights from OKC to Cancun in under 3 hours. Most popular destination for Edmond families seeking beach getaways and all-inclusive resorts.",
    urgency: "Last-minute Cancun charters and resort bookings peak March through August",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "UCO and Edmond professionals travel to London for conferences, study abroad, and business meetings. European river cruises often begin in London.",
    urgency: "Corporate and student travel has 7–14 day lead time in many cases",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Europe",
    context: "River cruises from Amsterdam and city tours of Paris, Rome, and Barcelona are popular among Edmond retirees and families in Oak Tree and Coffee Creek.",
    urgency: "European river cruise bookings are made 6–12 months in advance — passport renewals should be checked at booking time",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Germany",
    context: "UCO students participate in German exchange programs. Business travel to Frankfurt for automotive and manufacturing partnerships.",
    urgency: "Study-abroad deadlines create predictable October and February passport rush seasons",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Bahamas & Caribbean",
    context: "Caribbean cruises from Galveston and Miami are popular with Edmond families. Passport book required for all cruise travel.",
    urgency: "Cruise bookings peak January–February, but passport issues are discovered when final payment is due in March",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Ski trips to Banff and Calgary, and Niagara Falls visits. Passport book or card accepted for land and air crossings.",
    urgency: "Summer and winter family travel seasons drive consistent demand from Edmond families",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "45%",
    label: "of Edmond expedited requests involve family vacation or UCO study abroad coordination",
  },
  {
    stat: "2–4 Weeks",
    label: "average notice Edmond professionals have before an international business trip",
  },
  {
    stat: "June–Aug",
    label: "peak season when UCO study abroad, family vacations, and business travel collide",
  },
  {
    stat: "36 Hours",
    label: "shortest turnaround we have accommodated for an Edmond business executive with a last-minute London conference",
  },
];

export default function EdmondDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Edmond Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from north OKC metro clients. Understanding local travel behavior is part of why our document review catches issues before they derail your UCO study abroad program, family vacation, or business conference.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Oklahoma Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Oklahoma with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/cities/oklahoma-city" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Oklahoma City <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/norman" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Norman <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/cities/tulsa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tulsa <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}